import React from 'react';
import { Subtract } from 'utility-types';
import useWidth from '../hooks/useWidth';

export interface WithWidthProps {
    width: number;
}

const withWidth = <T extends WithWidthProps>(
    WrappedComponent: React.ComponentType<T>
): React.FC<Subtract<T, WithWidthProps>> => props => (
    <WrappedComponent {...props} width={useWidth()} />
);

export default withWidth;
